import esES from 'antd/lib/locale/es_ES';
import enUS from 'antd/lib/locale/en_US';
import { Locale } from 'antd/lib/locale-provider';
import { DEFAULT_LANGUAGE } from 'i18n';

const antdLocales: Record<string, Locale> = {
  es: esES,
  en: enUS,
};

const getAntdLocale = (language: string): Locale =>
  antdLocales[language] ?? antdLocales[DEFAULT_LANGUAGE];

export default getAntdLocale;
